"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlag = void 0;
const useExperiments_1 = require("./useExperiments");
function useFlag(name, params, takeFirst = false) {
    const { ready, flags } = (0, useExperiments_1.useExperiments)(params);
    const value = flags[name] || [];
    return {
        value: takeFirst ? (value[0] || '') : value,
        ready,
    };
}
exports.useFlag = useFlag;
